module.exports = __webpack_public_path__ + "static/media/creative_bg1.2c7628a1.jpg";